import { Alert } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { getDownloadURL, ref } from 'firebase/storage';
import { storage } from '../../firebase/firebase-config';

const size = '100%';

export const PDFViewer = ({ filename = '' }) => {
	const [datasheet, setDatasheet] = useState(null);
	useEffect(() => {
		if (filename.length > 0) {
			getDownloadURL(ref(storage, `fichas_tecnicas/${filename}.pdf`))
				.then((url) => {
					setDatasheet(url);
				})
				.catch((error) => console.log(error.message));
		} else {
			setDatasheet(null);
		}
	}, [filename]);

	return (
		<div style={{ width: '100%', height: '100%' }}>
			{datasheet ? (
				<embed
					type='application/pdf'
					src={datasheet}
					width={size}
					height={size}
				/>
			) : (
				<Alert severity='info'>
					No hay ficha técnica disponible para la prenda seleccionada
				</Alert>
			)}
		</div>
	);
};
